export default function AccessPending({ status, organizationName, onLogout }) {
    const rejected = status === 'Rejected';
    const org = organizationName || 'the organization';

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--bg-primary)',
            color: 'var(--text-primary)',
            padding: '2rem'
        }}>
            <div style={{
                maxWidth: '32rem',
                width: '100%',
                background: 'var(--bg-card)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius)',
                padding: '2rem'
            }}>
                <h1 style={{ margin: '0 0 0.75rem', fontSize: '1.4rem' }}>
                    {rejected ? 'Request for access was declined' : 'Request for access pending'}
                </h1>
                <p style={{ margin: 0, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
                    {rejected
                        ? `An administrator declined this request${organizationName ? ` for ${org}` : ''}. Contact them if you still need access.`
                        : 'A request for access has been received. You will receive an email when, and if, your request is approved.'}
                </p>
                <button type="button" className="btn-secondary" style={{ marginTop: '1.5rem' }} onClick={onLogout}>
                    Return to login
                </button>
            </div>
        </div>
    );
}
